import React from "react";
import style from "../mfseo.module.css";

export function textGenerator(content) {
  if (typeof content === "string")
    return <p className={style.greyText}>{content}</p>;
  else
    return (
      <ul>
        {" "}
        {content.map(points => {
          if (typeof points === "object")
            return (
              <ol>
                {" "}
                {points.map(li => {
                  return <li style={{ marginLeft: 48 }}>{li}</li>;
                })}
              </ol>
            );
          return <li>{points}</li>;
        })}
      </ul>
    );
}
